<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div  class="loading_custom" v-if="is_show_progress" >
         <ProgressBar :value="progress" style="width:300px;" />
      </div>
      <div class="card card-w-title">
        <div class="doc-header doc-title">
          <strong>{{ title }}</strong>
          <div class="p-col-12">
            <div class="p-col-12 header-buttons">
              <div class="left-buttons" style="margin: 0px 2px;">
                <Dropdown v-model="selectedOption" :options="dropdownOptions" optionLabel="label" optionValue="value" style="margin: 0px 2px" /> 
                <Calendar id="range" v-model="filterDate" selectionMode="range" :numberOfMonths="2" :manualInput="false" dateFormat="dd/mm/yy" :show-icon="true"/>
                <Button style="margin: 0px 2px" label="Tìm kiếm" icon="pi pi-search" @click="onFilterData"></Button>
                <Button style="margin: 0px 2px" label="Clear" class="p-button-danger" @click="clearFilterData"></Button>
              </div>
              <!-- <div class="right-buttons" style="" >
                <Button style="margin: 0px 10px"
                  v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.report_compare_agency.export == true || this.$store.getters.role == 'admin'"
                  label="Xuất các dòng đang chọn"
                  :disabled="selectedRows == null || selectedRows.length == 0"
                  class="p-button-raised style-btn-header"
                  @click="export_excel_office_court(2)"
                />
                <Button style="margin: 0px -5px"
                  v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.report_compare_agency.export == true || this.$store.getters.role == 'admin'"
                  label="Xuất tất cả"
                  class="p-button-raised style-btn-header"
                  @click="export_excel_office_court(1)"
                />
              </div> -->
            </div>
          </div>

          <div class="p-col-12">
            <div class="p-col-12 header-buttons" style="display: flex; justify-content: flex-end; gap: 10px;">
              <div class="right-buttons" style="display: flex; justify-content: flex-end; gap: 10px;" >
                <Button style="margin: 0px 10px"
                  v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.report_compare_agency && this.$store.getters.group_permission.report_compare_agency.export == true || this.$store.getters.role == 'admin'"
                  label="Xuất các dòng đang chọn"
                  :disabled="selectedRows == null || selectedRows.length == 0"
                  class="p-button-raised style-btn-header"
                  @click="export_excel_office_court(2)"
                />
                <Button style="margin: 0px -5px"
                  v-if="this.$store.getters.group_permission && this.$store.getters.group_permission.report_compare_agency && this.$store.getters.group_permission.report_compare_agency.export == true || this.$store.getters.role == 'admin'"
                  label="Xuất tất cả"
                  class="p-button-raised style-btn-header"
                  @click="export_excel_office_court(1)"
                />
              </div>
            </div>
          </div>

        </div>
        <DataTable :value="listDataService" :lazy="true" class="p-datatable-responsive" dataKey="id"
          @page="onPage($event)" :selection.sync="selectedRows" :paginator="pagination" :totalRecords="totalDataChange"
          :rows="paginationRows" :first="firstRecordIndex" :loading="loading" :filters="filters"
          :scrollable="(scrollHeight !== '' ? true : false) " :scrollHeight="scrollHeight" :autoLayout="true"
          :key="componentKey" :rowClass="rowClass" filterMatchMode="startsWith"
          :rowsPerPageOptions="$constants.LIST_OPTION_COMMON.PER_PAGE_OPTIONS" :currentPageReportTemplate="''"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown">
          <Column selectionMode="multiple" headerStyle="width: 3rem"></Column>
          <Column v-for="c in listColumns" :key="c.key" :field="getField(c)" :header="getLabel(c)"
            :filterMatchMode="getFilterMatch(c)" :filterFunction="customFilter" :sortable="getSortable(c)"
            :bodyClass="(c.class ? 'txt-' + c.class : '')" :bodyStyle="getHeaderStyle(c)"
            :headerStyle="getHeaderStyle(c)" :headerClass="(c.class ? 'txt-' + c.class : '')">
            <template #body="slotProps">
              <img v-if="getType(c) == 'Image'" :src="getData(c, slotProps.data)" style="width: 40px; height: 40px;" />
              <div v-else-if="c.type == 'Text'" v-html="getData(c, slotProps.data)" :style="(c.style ? c.style : '')">
              </div>
              <div v-else-if="getType(c) == 'Custom' || getType(c) == 'Icon'" v-html="getData(c, slotProps.data)"
                :style="(c.style ? c.style : '')"></div>
              <Checkbox v-else-if="getType(c) == 'Checkbox'" v-model="slotProps.data[slotProps.column.field]"
                :binary="true" @change="onInputChange($event, slotProps.data, c)" />
              <div v-else>
                <div v-if="c.custom">
                  <span v-if="c.custom == 'SelectionText'">{{ callbackDataSelect(c ,slotProps.data) }}</span>
                </div>
                <span v-else v-html="getData(c, slotProps.data)"
                  :class="getCustomClass(c, slotProps.data[c.key], slotProps.data)"></span>
              </div>
            </template>
            <template v-if="c.filter" #filter>
              <InputText v-if="c.filter.type == 'input'" type="text" v-model="filters[c.key]" class="p-column-filter"
                :placeholder="getFilterPlaceHolder(c)" @keyup="onFilter($event,c.filter.type,c.key)" />
              <div v-if="c.filter.type == 'select'">
                <Dropdown v-if="getField(c) == 'id_district_key'" :key="countDropdown" v-model="filters[getField(c)]"
                  :options="list_dictrict_filter" :optionLabel="c.filter.optionLabel" :optionValue="c.filter.optionKey"
                  :placeholder="getFilterPlaceHolder(c)" class="p-column-filter" :showClear="true" appendTo="body"
                  @change="onFilter($event,c.filter.type,c.key)">
                  <template #option="slotProps">
                    <div class="p-clearfix">
                      <span :class="getCustomClass(c, slotProps.option[c.filter.optionKey], slotProps.data)">{{
                        slotProps.option[c.filter.optionLabel] }}</span>
                    </div>
                  </template>
                </Dropdown>
              </div>
              <Calendar v-if="c.filter.type == 'DateRange'" :showOnFocus="false" :monthNavigator="true"
                :yearNavigator="true" yearRange="1900:2500" dateFormat="dd-mm-yy" id="date_from"
                v-model="filters[getField(c)]" class="p-column-filter" :showIcon="true" selectionMode="range"
                appendTo="body" :showClear="true" :showButtonBar="true"
                @clear-click="onFilter($event,c.filter.type,c.key)" @date-select="onFilter($event,c.filter.type,c.key)"
                :manualInput="true" />
            </template>
          </Column>
          <!-- <Column v-if="getRowActions()" headerStyle="width: 8em; text-align: center"
            bodyStyle="width: 8em; text-align: center">
            <template #body="slotProps">
              <span class="p-column-title">Actions</span>
              {{ slotProps.data.color }}
              <Button v-for="(a, k) in getRowActions().rows(slotProps.data)" :key="k" type="button"
                :icon="getIcon(a.icon)" :class="getClass(a.name)" :disabled="getDisabled(a.disabled)"
                style="margin-right: 0.5em;" v-on:click="actionsClicked(k, a, slotProps)"></Button>
            </template>
            <template #header="slotProps">
              <Button v-if="getRowActions().header" type="button" :icon="getIcon(getRowActions().header.icon)"
                :class="getClass(getRowActions().header.name)"
                v-on:click="actionsClicked(getRowActions().header.name, getRowActions().header, slotProps)"></Button>
            </template>
            <template #filter>
            </template>
          </Column> -->
          <template #empty>
            {{ $t('datatable.empty') }}
          </template>
          <template #loading>
            {{ $t('datatable.loading') }}
          </template>
          <template #footer>
            <!-- Tổng số mã cơ quan: {{ totalDataChange }}
            <span style="margin-left: 30px"></span> -->

<div style="min-width: 350px;">Tổng số mã cơ quan: {{ totalDataChange }}</div>
            <div style="display: flex; flex-wrap: wrap; gap: 12px; margin-top: 8px">
              
              <div style="min-width: 350px;">Tổng số VB TPHCM nhận: {{ count_document_city_received }}</div>
              <div style="min-width: 350px;">Tổng số VB TPHCM trả tòa: {{ count_document_city_return_court }}</div>
              <div style="min-width: 350px;">Tổng số VB TPHCM tồn: {{ count_document_city_outstanding }}</div>
              <div style="min-width: 350px;">Tổng số VB Tỉnh nhận: {{ count_document_province_received }}</div>
              <div style="min-width: 350px;">Tổng số VB Tỉnh trả tòa: {{ count_document_province_return_court }}</div>
              <div style="min-width: 350px;">Tổng số VB tỉnh tồn: {{ count_document_province_outstanding }}</div>
              <div style="min-width: 350px;">Số tiền VB TPHCM nhận: {{ money_city_received }}</div>
              <div style="min-width: 350px;">Số tiền VB TPHCM trả tòa: {{ money_city_return_court }}</div>
              <div style="min-width: 350px;">Số tiền VB Tỉnh nhận: {{ money_province_received }}</div>
              <div style="min-width: 350px;">Số tiền VB Tỉnh trả tòa: {{ money_province_return_court }}</div>
              <div style="min-width: 350px;">Tổng VB trả lại tòa (loại 4): {{ count_documents_returned_court }}</div>
              
            </div>
          </template>
        </DataTable>
        <div style="display: none;">
          <img id='barcode' />
        </div>
        <Dialog header="Xóa" :visible.sync="showDeleteDialog" :contentStyle="{overflow: 'visible'}" :modal="true">
          Bạn có chắc muốn xóa <strong>{{this.deleteName}}</strong>
          <template #footer>
            <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button label="Hủy" @click="showDeleteDialog = false" icon="pi pi-times" class="p-button-warning" />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>
<script>
import DataServices from '@/core/DataServices'
import moment from "moment-timezone";
import 'jspdf-autotable'
import store from '@/store'
import gql from "graphql-tag";
import graphql from '../common/graphql'
export default {
  components: {
  },
  data() {
    return {
      is_show_progress: false,
      progress: 0,
      total_price_all:0,
      text_total_page:'Tổng số văn bản: 0       Tổng tiền:0 ',
      filterOptions: {},
      listData: [],
      options: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false,
      totalDoc: 0,
      filters: {},
      countDropdown: 0,
      pagination: true,
      paginationRows: 10, 
      scrollHeight: '', 
      loading: true,
      rowsPerPageOptions: [5, 10, 20, 50, 100],
      selectedRows: null,
      hasErrors: 0,
      lstCurrDocument: {},
      onlyName: [],
      onlyDate: [],
      onlyAddress: [],
      lstCurrState: {},
      lstCurrDistrict: {},
      lstCurrWard: {},
      lstCurrOfficeTPL: {},
      lstCurrOfficeAgency: {},
      lstCurrArea: {},
      state_id: null,
      district_id: null,
      tpl_id: null,
      agency_id: null,
      area_id: null,
      is_fee_budget: 0,
      is_urgent : false,
      type_document: 1,
      code_system: null,
      tdv_id: null,
      refreshExport: 0,
      totalDataChange: 0,
      firstRecordIndex:0,
      totalRecordsL:0,
      listDataService:null,
      filtersCustom: [],
      lazyParams: {},
      componentKeyW: 0,
      listColumns: [],
      where_filter: {},
      list_dictrict_filter:[],
      list_ward_filter:[],
      list_holiday:[],
      role_key:null,
      dateType: 0,
      filterDate: null,
      selectedOption : null,

 count_document_city_received:0,
 count_document_city_return_court:0,
 count_document_city_outstanding:0,
 count_document_province_received:0,
 count_document_province_return_court:0,
 count_document_province_outstanding:0,
 money_city_received:0,
 money_city_return_court:0,
 money_province_received:0,
 money_province_return_court:0,
 count_documents_returned_court:0,

      dropdownOptions: [
        { label: 'Ngày nhận VB từ tòa', value: 1 },
        { label: 'Ngày trả VB từ tòa', value: 2 },
      ],
    }
  },
  beforeCreate() {
    if (store.getters.group_permission && store.getters.group_permission.report_compare_agency && store.getters.group_permission.report_compare_agency.list == false && store.getters.role != "admin") {
      this.$router.push({name: '404'})
    }
  },
  async created() {
    this.role_key = store.getters.role
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel('report_comparison_agency')
    this.title = this.dataModel.label
    this.lazyParams = {
      first: 0,
      rows: this.paginationRows,
      sortField: null,
      sortOrder: null,
      filters: this.filters
    };
     if (!this.$commonFuction.isEmpty(this.$route.query)){
       if (!this.$commonFuction.isEmpty(this.$route.query.page_transaction)){
         this.page_transaction = this.$route.query.page_transaction;
         this.lazyParams = (localStorage.getItem(this.page_transaction)) ? JSON.parse(localStorage.getItem(this.page_transaction)) : {};
         this.firstRecordIndex = this.lazyParams.first;
       }
     }
    this.filtersCustom = [];
    this.onLazyEvent(true);
    this.callbackOptions();
    var list_holiday =await this.$CoreService.getListHoliday();
    this.list_holiday = list_holiday;
  },
  mouted() {
    this.countDropdown++;
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    callbackDataSelect(c,data){
      var text = "";
      switch(c.key) {
        case 'id_ward_key':
          text = (!this.$commonFuction.isEmpty(data.ward)) ? data.ward.name:'';
          break;
        case 'id_district_key':
          text = (!this.$commonFuction.isEmpty(data.district)) ? data.district.name:'';
          break;
        case 'code_agency_tpl':
          text = (!this.$commonFuction.isEmpty(data.code_agency)) ? data.code_agency:'';
          break;
        default:
      }
      return text;
    },
    async export_excel_office_court(type) {
      //this.$store.commit('setLoadingCustom', true);
      var that = this;
      try {
        var dataPost = {
          role: this.$store.getters.role,
          type: type, // 1: tất cả, 2: các dòng đang chọn
          timezone_client: moment.tz.guess(),
          filterDate:  this.formatDate(this.lazyParams.filterDate) || [], // Truyền filterDate
          selectedOption: this.selectedOption || null // Truyền selectedOption
        };

        if (type == 2) {
          let arrIDs = [];
          if (this.selectedRows && this.selectedRows.length > 0) {
            for (let i = 0; i < this.selectedRows.length; i++) {
              arrIDs.push(this.selectedRows[i].id);
            }
          }
          dataPost.list_id = arrIDs;
          if (arrIDs.length < 1) {
            this.$toast.add({ severity: 'error', summary: 'Lỗi', detail: 'Vui lòng chọn ít nhất 1 cơ quan', life: 3000 });
            return false;
          }
        } else {
          dataPost.where_all = this.where_filter; // Truyền điều kiện lọc từ dataList
        }

        const headers = {
          "Authorization": "Bearer " + this.$store.getters.token,
        };
        this.is_show_progress = true;
        this.progress = 1;
        var dataResponse = await that.$CoreService.callApiPost('/_api/export_excel/export_office_agency', dataPost, headers);
        var id_history_export = dataResponse.data.data.id_history_export;
        var start = 0;
        var refreshIntervalId = setInterval(function () {
          if (start == 0) {
            start = 1;
            var dataPostFile = { id_history_export: id_history_export };
            that.$CoreService.callApiPost('/_api/export_excel/read_file_export', dataPostFile, {}).then(async (resData) => {
              if(parseInt(resData.data.data.percent) >0){
                that.progress = parseInt(resData.data.data.percent);
              }
              if (parseFloat(resData.data.data.process_status) == 1) {
                start = 0;
              } else if (parseFloat(resData.data.data.process_status) == 2) {
                 setTimeout(() => {
                  that.is_show_progress = false;
                  var link = document.createElement('a');
                link.href = resData.data.data.url;
                link.download = that.$commonFuction.basename(resData.data.data.url);
                link.dispatchEvent(new MouseEvent('click'));
                that.$store.commit('setLoadingCustom', false);
                
                  }, 2000);
                  clearInterval(refreshIntervalId);
                
              } else {
                that.is_show_progress = false;
                    alert("Xuất file thất bại");
               // that.$store.commit('setLoadingCustom', false);
                clearInterval(refreshIntervalId);
              }
            }).catch((error) => {
              clearInterval(refreshIntervalId);
              that.$store.commit('setLoadingCustom', false);
              if (error);
            });
          }
        }, 5000);
      } catch (err) {
        console.log("err:", err);
        that.is_show_progress = false;
                    alert("Xuất file thất bại");
        this.showConfirmDialog = true;
        this.creenConfirmDialog = 'export_err';
      }
    },
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel('report_comparison_agency');
      this.title = this.dataModel.label;
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    rowClass(data) {
      if (data.deadline_color === 1) return 'row-warning'
      else if (data.deadline_color === 2) return 'row-error'
      else return null;
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        if (field.options ) result = field.options;
        else if(field.models && this.options[name]) result = this.options[name];
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    async callbackOptions() {
      var fields = this.dataModel.getDisplayFields()
      var attributes = [];
      for (let index = 0; index < fields.length; index++) {
        const element = fields[index];
        if (element.models !== undefined && element.models !== null) {
          var optionsData = [];
          attributes.push(element.models.key.key);
          attributes.push(element.models.display_key);
          var where_status = {}
          if (element.key == 'code_agency_tpl'){
            where_status.deleted = {_eq: false};
            attributes.push('code');
          }
          var tableName = element.models.tableName
          var {data} = await this.$apollo.query({
            query: DataServices.getList(tableName, {"fields" : attributes.join(',')}),
            variables: {where_key : where_status}
          })
          if (data) {
            var result = data[Object.keys(data)];
            if (result) {
              for (let index = 0; index < result.length; index++) {
                const ele = result[index];
                if (element.key == 'code_agency_tpl') {
                  optionsData.push({value: ele['code'], label: ele['code']+' - '+ele['name']})
                }else {
                  optionsData.push({value: ele[attributes[0]], label: ele[attributes[1]]})
                }
              }
            }
          }
          this.options[element.key] = optionsData;
        }
        this.componentKey++;
      }
    },
    getRowActions() {
      var actions = {}
      var that = this;
      actions.rows = function (rowData) {
        var buttons = {}
        // if ((store.getters.group_permission && store.getters.group_permission.list_document.edit == true) || store.getters.role == "admin") {
        //   buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `report-comparison-agency/edit/`}
        // }
        // if ((store.getters.group_permission && store.getters.group_permission.list_document.delete == true) || store.getters.role == "admin") {
        //   buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        // }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async actionsClicked(key, action, data) {
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    deleteData() {
      var that =this;
      this.showDeleteDialog = false
      var pageTransaction = (new Date()).getTime();
      var query = DataServices.updateData(this.modelName)
      this.$store.commit('setLoadingCustom', true);
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        },
        'data_update': {
          'deleted': true
        },
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(() => {
        localStorage.setItem(pageTransaction.toString(), JSON.stringify(that.lazyParams));
        window.location.href = '/admin/list-document?page_transaction='+pageTransaction.toString();
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
      }).catch((error) => {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xóa dữ liệu gặp vấn đề', life: 3000 })
        console.error('ERROR: ', error)
        this.$store.commit('setLoadingCustom', false);
      });
    },

    getLabel(col) {
      if (col.label) return col.label;
      else return col.name;
    },
    getType(col) {
      if (col.display?.list?.mode == "custom") {
        return "Custom";
      }
      switch (col.type) {
        case "String":
        case "Text":
        case "Computed":
          if (col.inputOptions?.mode == "Image") {
            return "Image";
          }
          if (col.inputOptions?.mode == "selection") {
            return "Select";
          }
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          }
          if(col.inputOptions?.mode == 'icon') {
            return "Icon";
          }
          return "Input";
        case "numeric":
        case "ShadowField":
        case "number":
          if (col.inputOptions?.mode == "currency") {
            return "Currency";
          } else if (col.inputOptions?.mode == "percentage") {
            return "Percentage";
          } else {
            return "Number";
          }
        case "Selection":
          return "Select";
        case "Checkbox":
          return "Checkbox";
        default:
          return col.type;
      }
    },
    onInputChange(value, data, f) {
      if (f.onChange)  f.onChange(data).bind(this);
      this.$emit("onDataChange", data, f);
    },
    getCustomClass(col, data, rowData) {
      if (col.displayClass) return col.displayClass(data, rowData);
      return "";
    },
    getField(col) {
      return col.key;
    },
    getHeaderStyle(col) {
      var style = "";
      if (col.width) style = "width: " + col.width + "em;";
      else if (col.name === "stt" || col.name === "STT") style = "width: 3em;";
      else if (col.type === "image" || col.type === "Image") style = "width: 6em;";
      return style;
    },
    getData(col, row) {
      var value = '';
      if (col.type == "Date" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("DD/MM/yyyy");
      } else if (col.type == "Datetime" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm:ss DD/MM/yyyy");
      } else if (col.type == "CustomDate" && row[col.key]) {
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm - DD/MM/yyyy");
      } else if(col.type == "Hour" && row[col.key]){
        value = moment.tz(row[col.key], "Asia/Ho_Chi_Minh").format("HH:mm");
      } else if (col.type == "Selection") {
        var lists = [];
        if (col.options !== undefined) {
          lists = col.options;
        } else if (col.models !== undefined && this.options[col.key] !== undefined) {
          lists = this.options[col.key];
        }
        if (lists && lists.length) {
          var objResult = lists.filter(a => a.value == row[col.key]);
          if (objResult !== undefined && Object.keys(objResult) && Object.entries(objResult).length) {
            value = objResult[Object.keys(objResult)].label;
          }
        }
      } else {
        if (col.type == "Text" && row[col.key] && row[col.key].length > 100) {
          var result = row[col.key].substr(0, row[col.key].lastIndexOf(" ", 100)) + "...";
          value = result;
        }
        if (this.getType(col) == "Currency") {
          if (row[col.key] == null) row[col.key] = 0;
          value = this.formatCurrency(row[col.key]);
        }
        if (this.getType(col) == "Percentage") {
          if (row[col.key] == null) row[col.key] = `0%`;
          value = row[col.key] + "%";
        }
        value = row[col.key];
      }
      if (col.style) value = '<abbr style="' + col.style + '">' + value + '<abbr/>';
      else if (col.options) {
        var filtered = col.options.filter( a => a.value  === row[col.key]);
        if (Object.keys(filtered) && Object.entries(filtered).length && filtered[0].style) {
          value = '<abbr style="' + filtered[0].style + '">' + value + '<abbr/>';
        }
      }
      return value
    },
    getFilterMatch(col) {
      var filterMatch = "startWith";
      if (col.filter && col.filter.match) {
        filterMatch = col.filter.match;
      }
      return filterMatch;
    },
    getFilterPlaceHolder(col) {
      if (col.filter.placeHolder) {
        return col.filter.placeHolder;
      } else if (col.filter.type == "select") {
        return `Chọn ${this.getLabel(col).toLowerCase()}`;
      } else if (col.filter.type == "input") {
        return `Nhập ${this.getLabel(col).toLowerCase()}`;
      } else {
        return `Lọc`;
      }
    },
    getSortable(col) {
      return col.sortable && col.sortable == true ? true : false;
    },
    getIcon(iconName) {
      return `pi pi-${iconName}`;
    },
    getDisabled(disabled = false) {
      return disabled;
    },
    getClass(type) {
      switch (type) {
        case "add":
          return "p-button-add";
        case "delete":
          return "p-button-danger";
        case "edit":
          return "p-button-edit";
        case "adddebt":
          return "p-button-edit"
        case "add-Debt":
          return "p-button-add";
        case "editcustom":
          return "p-button-edit"
        case "addcustom":
          return "p-button-add";
      }
    },
    formatCurrency(value) {
      return value.toLocaleString("vi-VN", {
        style: "currency",
        currency: "VND"
      });
    },
    customFilter( itemLabel, filterValue) {
      return this.$CoreService.customFilterCore(itemLabel, filterValue , this.dateType);
    },
    onFilterDate(payload) {
      if (payload.col.filter.type == 'Date') this.dateType = 1;
      else if (payload.col.filter.type == 'DateRange') this.dateType = 2;
      else this.dateType = 0;
      if (payload.type != undefined && payload.type != '' && (payload.type == 'from' || payload.type == 'to')) {
        if (this.filters[payload.col.key] == undefined ) this.filters[payload.col.key] = {};
        if (payload.data != undefined) {
          this.filters[payload.col.key][payload.type] = payload.data;
          if (this.filters[payload.col.key] != null && this.filters[payload.col.key]['from'] != null && this.filters[payload.col.key]['to'] != null) {
            var date1 = new Date(moment(this.filters[payload.col.key]['from']).format('YYYY-MM-DD'));
            var date2 = new Date(moment(this.filters[payload.col.key]['to']).format('YYYY-MM-DD'));
            if (Number(date1) > Number(date2)) {
              var dateTemp = this.filters[payload.col.key]['from'];
              this.filters[payload.col.key]['from'] = this.filters[payload.col.key]['to'];
              this.filters[payload.col.key]['to'] = dateTemp;
            }
          }
        }
        else delete this.filters[payload.col.key][payload.type];
      } else {
        this.filters[payload.col.key] = payload.data;
      }
      this.$commonFuction.scroll_back_filter(payload.col.key+payload.type);
      this.componentKey = Math.random() * 320;
    },
    selectChangeDate(event, col, type = '') {
      var payload = {
        data: event,
        col: col,
        type: type,
        format: this.$commonFuction.formatDateCalenda('Date')
      }
      this.onFilterDate(payload);
    },
    clearChangeDate(col, type = '') {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (type == '') delete this.filters[this.getField(col)];
        else if (type != '' && date[type] != undefined && date[type] != null) delete this.filters[this.getField(col)][type];
      }
      var payload = {
        col: col,
        type: type,
      }
      this.onFilterDate(payload);
    },
    getValueDateRange(col, target) {
      var date = this.filters[this.getField(col)];
      if (date != null) {
        if (target != '') {
          if (date[target] != undefined && date[target] != null) {
            return moment(date[target]).format(this.$commonFuction.formatDateCalenda('Date'));
          }
        } else return moment(date).format(this.$commonFuction.formatDateCalenda('Date'));
      }
      return null;
    },
    onPage(event) {
      this.lazyParams = event;
      this.onLazyEvent();
    },
    formatDate(dateArray) {
      if (!Array.isArray(dateArray) || dateArray.length !== 2) {
        return [null, null];
      }

      const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().replace(/\.\d{3}Z$/, 'Z'); 
      };

      const adjustEndDate = (endDateString) => {
        const endDate = new Date(endDateString);
        endDate.setDate(endDate.getDate() + 1); 
        return endDate.toISOString().replace(/\.\d{3}Z$/, 'Z');
      };

      return [
        formatDate(dateArray[0]),
        adjustEndDate(dateArray[1]),
      ];
    },
    async renderSummary(list_code){
      const filterDate = this.formatDate(this.lazyParams.filterDate);
       var count_document_city_received =0;
       var count_document_city_return_court =0;
       var count_document_city_outstanding =0;
       var count_document_province_received =0;
       var count_document_province_return_court =0;
       var count_document_province_outstanding =0;
       var money_city_received =0;
       var money_city_return_court =0;
       var money_province_received =0;
       var money_province_return_court =0;
       var count_documents_returned_court =0;
      if(list_code.length > 0){
           count_document_city_received = await this.getSumDocumentCityReceived(list_code, filterDate, this.selectedOption);
           count_document_city_return_court = await this.getSumDocumentCityReturnCourt(list_code, filterDate, this.selectedOption);
          //total number of outstanding documents
           count_document_city_outstanding = count_document_city_received-count_document_city_return_court;
           count_document_province_received = await this.getSumDocumentProvinceReceived(list_code, filterDate, this.selectedOption);
           count_document_province_return_court = await this.getSumDocumentProvinceReturnCourt(list_code, filterDate, this.selectedOption);
          //total number of outstanding documents
           count_document_province_outstanding = count_document_province_received-count_document_province_return_court;
           money_city_received =this.formatCurrency(await this.getSumMoneyCityReceived(list_code, filterDate, this.selectedOption));
           money_city_return_court = this.formatCurrency(await this.getSumMoneyCityReturnCourt(list_code, filterDate, this.selectedOption));
           money_province_received = this.formatCurrency(await this.getSumMoneyProvinceReceived(list_code, filterDate, this.selectedOption));
           money_province_return_court = this.formatCurrency(await this.getSumMoneyProvinceReturnCourt(list_code, filterDate, this.selectedOption));
           count_documents_returned_court = await this.getSumDocumentReturnedCourt(list_code, filterDate, this.selectedOption);
      }
      this.count_document_city_received = count_document_city_received;
      this.count_document_city_return_court = count_document_city_return_court;
      this.count_document_city_outstanding = count_document_city_outstanding;
      this.count_document_province_received = count_document_province_received;
      this.count_document_province_return_court = count_document_province_return_court;
      this.count_document_province_outstanding = count_document_province_outstanding;
      this.money_city_received = money_city_received;
      this.money_city_return_court = money_city_return_court;
      this.money_province_received = money_province_received;
      this.money_province_return_court = money_province_return_court;
      this.count_documents_returned_court = count_documents_returned_court;
    },
    onLazyEvent(is_refesh_table = false) {
      this.lazyParams.filters = this.filtersCustom;
      this.lazyParams['filterDate'] = this.filterDate;
      
      this.loading = true;
      var that = this;
      var stt = this.lazyParams.first;
      const filterDate = this.formatDate(this.lazyParams.filterDate);
      this.dataList(this.lazyParams).then(async data => {
        var list_data = data.listData;
        const promises = list_data.map(async (item, index) => {
          item.sttKey = stt + index + 1;
          item.agency_tpl = item?.rel_office_agency_tpl_codes?.codes ?? '';
          // const filterDate = that.lazyParams.filterDate;
          item.count_document_city_received_type1 = await that.getSumDocumentCityReceived([item.code], filterDate, that.selectedOption, 1);
          item.count_document_city_received_type2 = await that.getSumDocumentCityReceived([item.code], filterDate, that.selectedOption, 2);
          item.count_document_city_received_type3 = await that.getSumDocumentCityReceived([item.code], filterDate, that.selectedOption, 3);
          item.count_document_city_received_type4 = await that.getSumDocumentCityReceived([item.code], filterDate, that.selectedOption, 4);
          item.count_document_city_received = await that.getSumDocumentCityReceived([item.code], filterDate, that.selectedOption);
          item.count_document_city_return_court = await that.getSumDocumentCityReturnCourt([item.code], filterDate, that.selectedOption);
          //total number of outstanding documents
          item.count_document_city_outstanding = item.count_document_city_received-item.count_document_city_return_court;
          item.count_document_province_received = await that.getSumDocumentProvinceReceived([item.code], filterDate, that.selectedOption);
          item.count_document_province_return_court = await that.getSumDocumentProvinceReturnCourt([item.code], filterDate, that.selectedOption);
          //total number of outstanding documents
          item.count_document_province_outstanding = item.count_document_province_received-item.count_document_province_return_court;
          item.money_city_received =this.formatCurrency(await that.getSumMoneyCityReceived([item.code], filterDate, that.selectedOption));
          item.money_city_return_court = this.formatCurrency(await that.getSumMoneyCityReturnCourt([item.code], filterDate, that.selectedOption));
          item.money_province_received = this.formatCurrency(await that.getSumMoneyProvinceReceived([item.code], filterDate, that.selectedOption));
          item.money_province_return_court = this.formatCurrency(await that.getSumMoneyProvinceReturnCourt([item.code], filterDate, that.selectedOption));
          item.count_documents_returned_court = await that.getSumDocumentReturnedCourt([item.code], filterDate, that.selectedOption);
         
         
         return item;
        });

        const updatedList = await Promise.all(promises);

        that.listColumns = DataServices.getModel('report_comparison_agency');
        this.listColumns.processData(updatedList);
        that.listColumns = this.listColumns.getDisplayFields();
        var list_display = [];
        if (this.$store.getters.role == 'court') {
          list_display.push('code_vplk');
        }
        if (list_display.length > 0) {
          this.listColumns = this.listColumns.filter(a => !list_display.includes(a.key));
        }
        var list_new_column = this.$commonFuction.convertJsonObject(this.listColumns);
        if (this.$store.getters.role == 'court') {
          for (var k = 0; k < list_new_column.length; k++) {
            var item_data = this.listColumns[k];
            if (item_data.name == 'code_agency_tpl') {
              this.listColumns[k]["filter"] = {};
            }
          }
        }
        this.renderSummary(data.list_code_full);
        that.firstRecordIndex = this.lazyParams.first;
        that.paginationRows = this.lazyParams.rows;
        that.listDataService = updatedList;
        that.totalDataChange = data.total;
        that.total_price_all = data.total_price;
        that.text_total_page = "Tổng số văn bản: " + that.totalDataChange + " \n       Tổng tiền:0 ";
        if (is_refesh_table);
        that.componentKey++;
        that.loading = false;
      });
    },
    removeDiacritics(str) {
      if (!str || typeof str !== 'string') return '';
      return str.trim().normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/đ/g, 'd')
      .replace(/Đ/g, 'D')
      .toLowerCase();
    },
    async dataList(lazyParams) {
      console.log('lazyParamslazyParams____________', lazyParams);
      console.log('selectedOptionselectedOption', this.selectedOption);

      try {
        const offset = lazyParams.first;
        const limit = lazyParams.rows;
        let where = {
          deleted: { _eq: false }
        };
        if (this.$store.getters.role === 'court' && this.$store.getters.user) {
          const list_code = await this.$CoreService.getListCodeAgencyCourt(this.$store.getters.user);
          where._and = where._and || [];
          where._and.push({ code_agency: { _in: list_code } });
        }
        const filterDate = this.formatDate(lazyParams.filterDate);
        if (filterDate && filterDate[0] && filterDate[1]) {
          if (this.selectedOption == 1) {
            // Filter theo ngày nhận (date_receipt_court)
            where._and = where._and || [];
            where._and.push({
              documents: {
                date_receipt_court: {
                  _gte: filterDate[0],
                  _lte: filterDate[1]
                }
              }
            });
          } else if (this.selectedOption == 2) {
            // Filter theo ngày trả tòa (date_return_court)
            where._and = where._and || [];
            where._and.push({
              documents: {
                date_return_court: {
                  _gte: filterDate[0],
                  _lte: filterDate[1]
                }
              }
            });
          } else {
            // Nếu không chọn selectedOption nhưng có filterDate, filter cả hai cột
            where._and = where._and || [];
            where._and.push({
              documents: {
                _or: [
                  { date_receipt_court: { _gte: filterDate[0], _lte: filterDate[1] } },
                  { date_return_court: { _gte: filterDate[0], _lte: filterDate[1] } }
                ]
              }
            });
          }
        }
        const filters = lazyParams.filters;
        if (filters) {
          for (const [key, value] of Object.entries(filters)) {
            if (!this.$commonFuction.isEmpty(value.value)) {
              const normalizedValue = this.removeDiacritics(value.value);
              switch (value.type_input) {
                case 'input':
                  switch (key) {
                    case 'name':
                        where.name_no_diacritics = { _ilike: `%${normalizedValue}%` };
                      break;
                    case 'agency_tpl_key':
                        where.rel_office_agency_tpl_codes = {codes: { _ilike: `%${normalizedValue}%` } };
                      break;
                    default:
                      where[key] = { _ilike: `%${value.value}%` };
                  }
                  break;
                case 'DateRange':
                  where[key] = { _gte: value.value.from, _lte: value.value.to };
                  break;
                case 'select':
                  switch (key) {
                    case 'id_district_key':
                      where.district_id = { _eq: value.value };
                      break;
                    case 'id_ward_key':
                      where.ward_id = { _eq: value.value };
                      break;
                    case 'code_agency_tpl':
                      where.code_agency = { _eq: value.value };
                      break;
                    default:
                      where[key] = { _eq: value.value };
                  }
                  break;
                case 'MultiSelect':
                  break;
                default:
              }
            }
          }
        }
        const variables = {
          where: where,
          orderBy: [{ id: 'desc' }],
          offset: offset,
          limit: limit
        };
        this.where_filter = where;
        const response = await this.$apollo.query({
          query: gql(graphql.GET_REPORT_OFFICE_AGENCY),
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data_list = response.data;
        let list = [];
        let list_code_full = [];
        if (!this.$commonFuction.isEmpty(data_list.office_agency)) {
          list = data_list.office_agency;
        }
        if (!this.$commonFuction.isEmpty(data_list.office_agency_full)) {
          for(var i = 0; i < data_list.office_agency_full.length; i++){
            list_code_full.push(data_list.office_agency_full[i].code);
          }
        }
        const total = data_list.office_agency_aggregate?.aggregate?.count || 0;
        const total_price = 0;
        const dataRes = {
          listData: list,
          total: total,
          total_price: total_price,
          list_code_full: list_code_full
        };
        this.$store.commit('setLoading', false);
        return dataRes;
      } catch (error) {
        console.error('Error fetching data:', error);
        this.$store.commit('setLoading', false);
        return {
          listData: [],
          total: 0,
          total_price: 0
        };
      }
    },
    async getSumDocumentCityReceived(list_code_agency, filterDate, selectedOption, typeDocument = null) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          date_receipt_court: { _is_null: false },
          type_state: { _eq: 1 },
          deleted: { _eq: false }
        };
        if (!this.$commonFuction.isEmpty(typeDocument)) {
          where.type_document = { _eq: typeDocument };
        }
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 1) {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 2) {
            // where["date_receipt_court"] = {
            //   _gte: filterDate[0],
            //   _lte: filterDate[1]
            // };
            where["date_return_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
            // Không áp dụng filter nếu selectedOption là 2 (ngày trả)
          } else {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumDocumentCityReceived($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              count
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let count_document_city_received = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          count_document_city_received = data.document_aggregate.aggregate.count;
        }
        return count_document_city_received;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },

    async getSumDocumentCityReturnCourt(list_code_agency, filterDate, selectedOption) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          date_return_court: { _is_null: false },
          type_state: { _eq: 1 },
          deleted: { _eq: false }
        };
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 2) {
            // where["date_receipt_court"] = {
            //   _gte: filterDate[0],
            //   _lte: filterDate[1]
            // };
            where.date_return_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 1) {
            where["date_receipt_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
     
          } else {
            where.date_return_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumDocumentCityReturnCourt($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              count
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let count_document_city_return_court = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          count_document_city_return_court = data.document_aggregate.aggregate.count;
        }
        return count_document_city_return_court;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },

    async getSumDocumentProvinceReceived(list_code_agency, filterDate, selectedOption) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          date_receipt_court: { _is_null: false },
          type_state: { _eq: 2 },
          deleted: { _eq: false }
        };
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 1) {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 2) {
            // where["date_receipt_court"] = {
            //   _gte: filterDate[0],
            //   _lte: filterDate[1]
            // };
            where["date_return_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
            // Không áp dụng filter nếu selectedOption là 2 (ngày trả)
          } else {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumDocumentProvinceReceived($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              count
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let count_document_province_received = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          count_document_province_received = data.document_aggregate.aggregate.count;
        }
        return count_document_province_received;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },

    async getSumDocumentProvinceReturnCourt(list_code_agency, filterDate, selectedOption) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          date_return_court: { _is_null: false },
          type_state: { _eq: 2 },
          deleted: { _eq: false }
        };
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 2) {
            where.date_return_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 1) {
            // Không áp dụng filter nếu selectedOption là 1 (ngày nhận)
            where["date_receipt_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else {
            where.date_return_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumDocumentProvinceReturnCourt($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              count
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let count_document_province_return_court = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          count_document_province_return_court = data.document_aggregate.aggregate.count;
        }
        return count_document_province_return_court;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },

async getSumDocumentReturnedCourt(list_code_agency, filterDate, selectedOption) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          //date_receipt_court: { _is_null: false },
          //type_state: { _eq: 1 },
          status_td_id: { _eq: 8 },//hình thức trả lại tòa
          type_document: { _eq: 4 },//hình thức trả lại tòa
          deleted: { _eq: false }
        };
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 1) {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 2) {
            // where["date_receipt_court"] = {
            //   _gte: filterDate[0],
            //   _lte: filterDate[1]
            // };
            where["date_return_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
            // Không áp dụng filter nếu selectedOption là 2 (ngày trả)
          } else {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumDocumentReturnedCourt($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              count
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let count_document_returned_court = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          count_document_returned_court = data.document_aggregate.aggregate.count;
        }
        return count_document_returned_court;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },

    async getSumMoneyCityReceived(list_code_agency, filterDate, selectedOption) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          date_receipt_court: { _is_null: false },
          type_state: { _eq: 1 },
          deleted: { _eq: false }
        };
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 1) {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 2) {
            // where["date_receipt_court"] = {
            //   _gte: filterDate[0],
            //   _lte: filterDate[1]
            // };
            where["date_return_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
            // Không áp dụng filter nếu selectedOption là 2 (ngày trả)
          } else {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumMoneyCityReceived($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              sum {
                cost_document
              }
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let money_city_received = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          money_city_received = data.document_aggregate.aggregate.sum.cost_document || 0;
        }
        return money_city_received;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },

    async getSumMoneyCityReturnCourt(list_code_agency, filterDate, selectedOption) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          date_return_court: { _is_null: false },
          type_state: { _eq: 1 },
          deleted: { _eq: false }
        };
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 2) {
            // where["date_receipt_court"] = {
            //   _gte: filterDate[0],
            //   _lte: filterDate[1]
            // };
            where.date_return_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 1) {
            where["date_receipt_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
            // Không áp dụng filter nếu selectedOption là 1 (ngày nhận)
          } else {
            where.date_return_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumMoneyCityReturnCourt($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              sum {
                cost_document
              }
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let money_city_return_court = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          money_city_return_court = data.document_aggregate.aggregate.sum.cost_document || 0;
        }
        return money_city_return_court;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },

    async getSumMoneyProvinceReceived(list_code_agency, filterDate, selectedOption) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          date_receipt_court: { _is_null: false },
          type_state: { _eq: 2 },
          deleted: { _eq: false }
        };
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 1) {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 2) {
            // where["date_receipt_court"] = {
            //   _gte: filterDate[0],
            //   _lte: filterDate[1]
            // };
            where["date_return_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
            // Không áp dụng filter nếu selectedOption là 2 (ngày trả)
          } else {
            where.date_receipt_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumMoneyProvinceReceived($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              sum {
                cost_document
              }
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let money_province_received = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          money_province_received = data.document_aggregate.aggregate.sum.cost_document || 0;
        }
        return money_province_received;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },

    async getSumMoneyProvinceReturnCourt(list_code_agency, filterDate, selectedOption) {
      try {
        let where = {
          code_agency: { _in: list_code_agency },
          date_return_court: { _is_null: false },
          type_state: { _eq: 2 },
          deleted: { _eq: false }
        };
        if (filterDate && filterDate.length === 2) {
          if (selectedOption == 2) {
            where.date_return_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          } else if (selectedOption == 1) {
            where["date_receipt_court"] = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
            // Không áp dụng filter nếu selectedOption là 1 (ngày nhận)
          } else {
            where.date_return_court = {
              _gte: filterDate[0],
              _lte: filterDate[1]
            };
          }
        }
        const variables = { where };
        const response = await this.$apollo.query({
          query: gql`
        query getSumMoneyProvinceReturnCourt($where: document_bool_exp!) {
          document_aggregate(where: $where) {
            aggregate {
              sum {
                cost_document
              }
            }
          }
        }
      `,
          variables: variables,
          fetchPolicy: 'network-only'
        });
        const data = response.data;
        let money_province_return_court = 0;
        if (!this.$commonFuction.isEmpty(data.document_aggregate)) {
          money_province_return_court = data.document_aggregate.aggregate.sum.cost_document || 0;
        }
        return money_province_return_court;
      } catch (error) {
        console.error('Error fetching data:', error);
        return 0;
      }
    },


    async onFilter(event,type_input,key) {
      if (key == 'state_id'){
        if (!this.$commonFuction.isEmpty(event.value)){
          this.list_dictrict_filter =await this.$CoreService.getDistrictByIdState(event.value);
        }else {
          this.list_dictrict_filter = [];
        }
        this.list_ward_filter = [];
      }else if (key == 'id_district_key'){
        if (!this.$commonFuction.isEmpty(event.value)){
          this.list_ward_filter =await this.$CoreService.getWardByIdDistrict(event.value);
        }else {
          this.list_ward_filter = [];
        }
      }
      this.filtersCustom[key] = await this.$CoreService.convertFilter(type_input,key,this.filters);
    },
    async onFilterData() {
      this.onLazyEvent()
    },
    async clearFilterData() {
      this.filtersCustom = [];
      this.filters = {};
      this.filterDate = null;
      this.onLazyEvent()
    },
    sortTable(event) {
      var sortby = 'asc'
      this.orderBy = {}
      if(event.sortOrder == -1){
        sortby = 'desc'
      }
      this.orderBy[event.sortField] = sortby
      this.lazyParams.first = 0;
      this.onLazyEvent()
    },
    async popupDeleteDosc() {
      this.displayDialog = true
      this.editDialogKey = Math.floor(Math.random() * (30))
    }
  },
}
</script>
<style lang="scss">
.p-datepicker { top: 0px !important;}
.p-calendar .p-datepicker { padding: 0px !important; min-width: 100% !important;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group {
  border-right: 1px solid #d8dae2 !important;
  padding-left: 0.857rem !important;
  padding-right: 0.857rem !important;
  background: #fff !important;
}
.p-datepicker.p-datepicker-multiple-month .p-datepicker-group:last-child {
  border: 1px solid #c8c8c8 !important;
}
.doc-header {
  &.doc-title {
    color: #1D3118;
    text-transform: capitalize;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
  }
  .title-filter {
    margin-left: 24px;
    font-size: 14px;
  }
  .btn-enter-filter {
    background-color: #0A84FF !important;
    margin-left: 10px;
    padding: 6px 30px;
  }
}
.box-selected-file {
  // padding: 10px;
  position: relative;
  width: fit-content;
  float: right;
  margin-top: 5px;
  margin-bottom: 5px;
  input.file {position: absolute; opacity: 0;cursor: pointer;}
}
.box-selected-file span {
  padding: 7px 15px;
  background: #0A84FF 0% 0% no-repeat padding-box;
  border: 1px solid #0A84FF;
  border-radius: 3px;
  cursor: pointer;
  font-size: 0.875rem;
  color: #ffffff;
}
.p-checkbox .p-hidden-accessible{
  position: unset!important;
}

.header-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.left-buttons {
  text-align: left;
}

.right-buttons {
  text-align: right;
}


</style>